// const baseurl='https://esusong.cdelink.cn:443/resource/'
const baseurl='https://www.jpito.com/resource/'
// const baseurl='http://192.168.0.2:9999/resource/'
export default baseurl